import { Button } from "@/components/chadcn/Button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/chadcn/Dialog"
import Spinner from "@/components/Spinner"
import { useLogOutMutation } from "@/data/queries"
import { ROUTES } from "@/routes"
import { useNavigate } from "react-router"

type SkipSetupModalProps = {
  open: boolean
  onClose: () => void
}

const SkipSetupModal = ({ open, onClose }: SkipSetupModalProps) => {
  const navigate = useNavigate()
  const { mutate: logOut, isPending } = useLogOutMutation()

  const handleLogOut = () => {
    logOut(undefined, {
      onSuccess: () => navigate(ROUTES.SIGN_IN, { replace: true }),
    })
  }

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-xs">
        <DialogHeader>
          <DialogTitle className="px-8 text-center text-h4">
            Whenever you&apos;re ready to proceed, log back in!
          </DialogTitle>
        </DialogHeader>
        <Button
          type="button"
          className="flex w-full gap-3 py-2 text-base"
          disabled={isPending}
          onClick={handleLogOut}
        >
          {isPending && <Spinner />}
          OK
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default SkipSetupModal
